import { useCallback } from "react"
import { Slider, Stack, StackProps, Typography } from "@mui/material"

type AuthorGraphSliderBarProps = {
	listCount: number
	limit: number
	setLimit: (limit: number) => void
} & StackProps
export const AuthorGraphSliderBar = ({
	listCount,
	limit,
	setLimit,
	...others
}: AuthorGraphSliderBarProps) => {
  const onChangeLimit = useCallback(
		(event: Event, newValue: number) => setLimit(newValue),
		[setLimit]
	)
	return (
		<Stack {...others} spacing={4} direction='row'>
			<Stack spacing={1} direction='row' alignItems='center'>
				<Typography variant="body2" whiteSpace="nowrap">表示人数</Typography>
				<Slider
					value={limit}
					onChange={onChangeLimit}
					valueLabelDisplay="on"
					min={Math.min(10, listCount)}
					max={Math.min(500, listCount)}
					sx={{ width: "15em" }}
				/>
			</Stack>
		</Stack>
	)
}
